module.exports = __webpack_public_path__ + "img/yunnan03.10b427db.png";